<app-header [forceLightBackground]="true"></app-header>
<div class="provider-my-projects">
  <div class="provider-my-projects--layout">
    <app-provider-sidebar class="provider-my-projects--sidebar"></app-provider-sidebar>
    <div class="provider-my-projects--content">
      <app-page-header></app-page-header>

      @if (accessLevel === 'loading') {
        <div class="provider-my-projects--access provider-my-projects--access-loading">
          <p>Checking access...</p>
        </div>
      }

      @if (accessLevel === 'full') {
        <app-my-project></app-my-project>
      }
    </div>
  </div>
</div>

<app-modal
  [visible]="showAccessModal"
  header="Upgrade Your Role"
  width="480px"
  [showFooter]="false"
  (visibleChange)="onAccessModalClose()"
>
  <div class="provider-my-projects--modal-content">
    <div class="provider-my-projects--modal-body">
      @if (accessLevel === 'none') {
        <p>
          You need the Compute role to access My Projects. Request the Compute role or contact your administrator.
        </p>
      }
      @if (accessLevel === 'pending') {
        <p>
          Your Compute role request is pending
          <span class="provider-my-projects--modal-highlight">approval</span>.
          You will get access to My Projects once it is approved.
        </p>
      }
      <div class="provider-my-projects--modal-actions">
        <button
          type="button"
          class="provider-my-projects--role-upgrade-btn"
          [disabled]="accessLevel === 'pending'"
          (click)="onRoleUpgradeClick()"
        >
          {{ accessLevel === 'pending' ? 'Request Sent' : 'Role Upgrade' }}
        </button>
      </div>
    </div>
  </div>
</app-modal>
